export default "__VITE_ASSET__i_c8FZIH__"